import React, { memo } from "react";
import { toggleSidebar } from "./Main/Main-Actions";
import store from "./../../store";
import useClassToggle from "../../hooks/useClassToggle";
import Div from "../common/Div/Div";
import useAppState from "../../hooks/useAppState";
import {useSelector} from "react-redux";

const MainHeader = () =>
{
  const reduxState = useSelector(state => state);
  const {main} = reduxState;
  const sidebarOpen = main.data.sidebar.open;
  // useClassToggle(`menu-open`, `body`, sidebarOpen );
  let root = document.getElementsByTagName( 'html' )[0];
  const toggleNavbarbar = () => {
    root.classList.add('menu-active');
    store.dispatch( toggleSidebar() );
    let element = document.getElementById('div-sidebar-wrapper');
    if( sidebarOpen ) {
      element.classList.remove('active');
      document.body.classList.remove('menu-active');
      root.classList.remove('menu-active');
    } else {
      element.classList.add('active');
      document.body.classList.add('menu-active');
    }
    /*if( root.classList.contains('menu-active') ) {
      document.body.classList.remove('sidebar-minimised');
    } else {
      document.body.classList.add('sidebar-minimised');
    }*/
  }
  return (

    <header>
      <Div className="container-fluid p-0">
        <Div className="row">
          <Div className="col-md-12">
            <nav className="navbar main-nav">
              <Div className="brandLogo" >
              <a href="" />
              </Div>
              {/*<a href=""><span className="icon-hdl"/></a>*/}
              {/*<Div className={[ `navbar-toggle-btn`, sidebarOpen && `open` ]}
                   onClick={() => store.dispatch( toggleSidebar( ))}>
                <span/><span/><span/>
              </Div>*/}
              <div className={`navbar-toggle-btn ${ sidebarOpen ? `open` : null }`}  onClick={ toggleNavbarbar }>
                <span/>
                <span/>
                <span/>
              </div>
            </nav>
          </Div>
        </Div>
      </Div>
    </header>

  )
};


export default memo( MainHeader );